import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendMetaEvent } from '../services/metaCapi';

/**
 * Hook para disparar eventos manuais (cliques, conversões) unificados (Meta + Google)
 */
export const useMetaTracking = () => {
  const trackEvent = (eventName, params = {}, userData = {}) => {
    // 1. Meta Pixel (Navegador)
    if (window.fbq) {
      window.fbq('track', eventName, params);
    }

    // 2. Google Ads (Gtag)
    if (window.gtag) {
      window.gtag('event', eventName, {
        ...params,
        send_to: 'AW-18028169328'
      });
    }

    // 3. Meta CAPI (Servidor)
    sendMetaEvent(eventName, params, userData);
  };

  const trackContact = () => {
    trackEvent('Contact', {
      content_category: 'Atendimento',
      content_name: 'Clique Botão WhatsApp'
    });
  };

  return { trackContact, trackEvent };
};

/**
 * Componente para rastreamento automático de visualização de página.
 * Deve ser usado apenas UMA VEZ no App.jsx
 */
export const MetaPageViewTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    if (lastPath.current === currentPath) return;
    lastPath.current = currentPath;

    // Rastreamento Meta
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: document.title,
        content_category: 'Navegação',
        url: window.location.href
      });
    }

    // Rastreamento Google Ads (Page View)
    if (window.gtag) {
      window.gtag('config', 'AW-18028169328', {
        page_path: currentPath,
        page_title: document.title
      });
    }

    sendMetaEvent('ViewContent', {
      content_name: document.title,
      content_category: 'Navegação',
      params: { url: window.location.href }
    });
  }, [location]);

  return null;
};